import { Injectable } from '@angular/core';
import { Http, Response, Headers, URLSearchParams, Jsonp, ResponseContentType} from '@angular/http';
import { Subject, Subscription } from 'rxjs/Rx';
import {AuthService} from "./auth.service";
import { Router } from "@angular/router";
import * as moment from 'moment';
import * as saveAs from 'file-saver';

@Injectable()
export class BillsService extends AuthService{

    private URLGetCleanerBills = "api/v1/getInvoiceCleaners/";
    private URLGetGYHBills = "api/v1/getInvoiceGYH/";
    private URLSetPaymentBill = "api/v1/switchPayed/:id/:pay";
    private URLEXportDownloadPDF = "https://api.pdflayer.com/api/convert";
    private URLSendBill = "api/v1/sendBill/:id";
    private URLSearchCleanerBills = "api/v1/searchCleanerInvoices/";
    private URLSearchGYHBills = "api/v1/searchGYHInvoices/";
    private URLGetUserBillDetail = "api/v1/getUserInvoiceDetail/:id";
    private URLGetCleanerBillDetail = "api/v1/getCleanerInvoiceDetail/:id";
    private URLGetHTMLInvoice = "downloadInvoice/:id/:userId/:period/:invoiceNumber";
    private URLGetGYHHTMLInvoice = "downloadCleanerInvoice/:id/:period/:invoiceNumber";
    private URLGetGYHHTMLInvoiceWN = "downloadInvoice/:id/:userId/:period";
    private URLGenerateUserBills = "generateInvoices/:period";
    private URLGenerateCleanerBills = "generateCleanerInvoices/:period";
    private ACCESS_KEY_PDF = "f9b166de93e938c942604f6a332ca472";
    private ID = ":id";
    private CIF = ":cif";
    private PAY = ":pay";
    private USERID = ":userId";
    private PERIOD = ":period";
    private NUMBER = ":invoiceNumber";
    
    constructor(public http: Http, public router: Router) {
        super(http, router);
    }

    public generateUserBills(period: string){
        let URLGenerateUserBills = this.URLGenerateUserBills.replace(this.PERIOD, period);
        return this.http.get(this.APIURL + URLGenerateUserBills, { headers: this.headers })
        .map((res: Response) => res["statusText"]);
    }

    public generateCleanerBills(period: string){
        let URLGenerateCleanerBills = this.URLGenerateCleanerBills.replace(this.PERIOD, period);
        return this.http.get(this.APIURL + URLGenerateCleanerBills, { headers: this.headers })
        .map((res: Response) => res["statusText"]);
    }

    public setBillPayment(id: string, pay: string) {
        let URLSetPaymentBill = this.URLSetPaymentBill.replace(this.ID, id).replace(this.PAY,pay);
        return this.http.get(this.APIURL + URLSetPaymentBill, { headers: this.headers })
        .map((res: Response) => res.json()["status"]);
    }

    public downloadBill(id: string, userId: string, period: string, number: string) {
        let headers = new Headers();
        headers.append("Content-type","application/x-www-form-urlencoded; application/json");
        let URLGetHTMLInvoice = this.URLGetHTMLInvoice.replace(this.ID, id).replace(this.USERID, userId).replace(this.PERIOD, period).replace(this.NUMBER, number);
        //let url = this.APIURL + URLGetHTMLInvoice;
        let url = "https://api.getyourhero.com/" + URLGetHTMLInvoice;
        return this.http.get( this.URLEXportDownloadPDF + "?access_key=" + this.ACCESS_KEY_PDF + "&document_url="+ url +"&page_size=A4",  { responseType: ResponseContentType.Blob })
        .map((response) => {
            return new Blob([response["_body"]], { type: 'application/pdf' })
        });
    }

    public downloadBillGYH(cleanerId: string, period: string, number: string) {
        let headers = new Headers();
        headers.append("Content-type","application/x-www-form-urlencoded; application/json");
        let URLGetGYHHTMLInvoice = this.URLGetGYHHTMLInvoice.replace(this.ID, cleanerId).replace(this.PERIOD, period).replace(this.NUMBER, number);
        //console.log(URLGetGYHHTMLInvoice);
        //let url = this.APIURL + URLGetGYHHTMLInvoice;
        let url = "https://api.getyourhero.com/" + URLGetGYHHTMLInvoice;
        return this.http.get( this.URLEXportDownloadPDF + "?access_key=" +  this.ACCESS_KEY_PDF + "&document_url="+ url +"&page_size=A4",  { responseType: ResponseContentType.Blob })
        .map((response) => {
            return new Blob([response["_body"]], { type: 'application/pdf' })
        });
    }

    public getInvoiceHTML(id: string, userId: string, period: string, number: string){
        let URLGetHTMLInvoice = this.URLGetHTMLInvoice.replace(this.ID, id).replace(this.USERID, userId).replace(this.PERIOD, period).replace(this.NUMBER, number);
        return this.http.get(this.APIURL + URLGetHTMLInvoice, { headers: this.headers })
        .map((res: Response) => res["_body"]);
    }

    public getInvoiceHTMLGYH(idCleaner: string, period: string) {
        let URLGetGYHHTMLInvoice = this.URLGetGYHHTMLInvoice.replace(this.ID, idCleaner).replace(this.PERIOD, period).replace(this.NUMBER, "");
        return this.http.get(this.APIURL + URLGetGYHHTMLInvoice, { headers: this.headers })
        .map((res: Response) => res["_body"]);
    }

    public sendBill(id: string) {
        let URLSendBill = this.URLSendBill.replace(this.ID, id);
        return this.http.get(this.APIURL + URLSendBill, { headers: this.headers })
        .map((res: Response) => res.json()["data"]);
    }

    public getCleanerBills() {
        return this.http.get(this.APIURL + this.URLGetCleanerBills, { headers: this.headers })
        .map((res: Response) => res.json()["data"])
        .filter(bills => {
            bills.forEach(element => {
                element["amount"] = element["amount"].toFixed(2);
                element["date_period"] = moment(element["date_period"],"YYYY-MM").format("MM/YYYY");
            });
            return true
        });
    }
    public getGYHBills() {
        return this.http.get(this.APIURL + this.URLGetGYHBills, { headers: this.headers })
        .map((res: Response) => res.json()["data"])
        .filter(bills => {
            bills.forEach(element => {
                element["amount"] = element["amount"].toFixed(2);
                element["date_period"] = moment(element["date_period"],"YYYY-MM").format("MM/YYYY");
            });
            return true
        });
    }
    public searchBillsCleaner(data: object) {
        return this.http.post(this.APIURL + this.URLSearchCleanerBills, data, { headers: this.headers })
        .map((res: Response) => res.json()["data"])
        .filter(bills => {
            bills.forEach(element => {
                element["amount"] = element["amount"].toFixed(2);
            });
            return true;
        });
    }

    public searchBillsGYH(data: object) {
        return this.http.post(this.APIURL + this.URLSearchGYHBills, data, { headers: this.headers })
        .map((res: Response) => res.json()["data"])
        .filter(bills => {
            bills.forEach(element => {
                element["amount"] = element["amount"].toFixed(2);
            });
            return true;
        });
    }

    public getUserBillDetail(id: string) {
        let URLGetUserBillDetail = this.URLGetUserBillDetail.replace(this.ID, id);
        return this.http.get(this.APIURL + URLGetUserBillDetail, { headers: this.headers })
        .map((res: Response) => res.json()["data"])
        .filter(bill => {
            
            bill["discount"] = (bill["discount"]).toFixed(2);
            //bill["total"] = (bill["amount"]).toFixed(2);
            bill["subtotal"] = 0;
            bill["total"] = 0;
            bill["services"].forEach(service => {
                service["date"] = moment(service["date"],"YYYY-MM-DD").format("DD/MM/YYYY");
                var integer = parseInt(service["n_hours"]);
                var decimals = service["n_hours"] - integer;
                var minutes = (decimals == 0) ? ":00" : ":30";
                service["n_hours"] = integer + minutes;
                bill["subtotal"] += service["subtotal_amount"];
                bill["total"] += service["total_amount"];
                service["total_amount"] = service["total_amount"].toFixed(2);
                service["subtotal_amount"] = service["subtotal_amount"].toFixed(2);
            });

            bill["iva_amount"] = (bill["subtotal"] * 0.21).toFixed(2);
            bill["subtotal"] = bill["subtotal"].toFixed(2);
            bill["total"] = bill["total"].toFixed(2);
            return true;
        });
    }

    public getCleanerBillDetail(id: string) {
        let URLGetCleanerBillDetail = this.URLGetCleanerBillDetail.replace(this.ID, id);
        return this.http.get(this.APIURL + URLGetCleanerBillDetail, { headers: this.headers })
        .map((res: Response) => res.json()["data"])
        .filter(bill => {
            bill["subtotal"] = 0;
            bill["total"] = 0;
            bill["services"].forEach(service => {
                service["date"] = moment(service["date"],"YYYY-MM-DD").format("DD/MM/YYYY");
                var integer = parseInt(service["n_hours"]);
                var decimals = service["n_hours"] - integer;
                var minutes = (decimals == 0) ? ":00" : ":30";
                service["n_hours"] = integer + minutes;
                bill["subtotal"] += service["subtotal_amount"];
                bill["total"] += service["total_amount"];
                service["total_amount"] = service["total_amount"].toFixed(2);
                service["subtotal_amount"] = service["subtotal_amount"].toFixed(2);
            });

            bill["iva_amount"] = (bill["subtotal"] * 0.21).toFixed(2);
            bill["subtotal"] = bill["subtotal"].toFixed(2);
            bill["total"] = bill["total"].toFixed(2);
            return true;
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/injections/bills.service.ts